/**
 * Complete Country + State/Province list for UPS-compatible address forms.
 * ISO 3166-1 alpha-2 country codes
 * Includes states/provinces where commonly required by UPS APIs.
 */

const COUNTRIES = [
  {
    name: "United States",
    code: "US",
    states: [
      { name: "Alabama", code: "AL" },
      { name: "Alaska", code: "AK" },
      { name: "Arizona", code: "AZ" },
      { name: "Arkansas", code: "AR" },
      { name: "California", code: "CA" },
      { name: "Colorado", code: "CO" },
      { name: "Connecticut", code: "CT" },
      { name: "Delaware", code: "DE" },
      { name: "Florida", code: "FL" },
      { name: "Georgia", code: "GA" },
      { name: "Hawaii", code: "HI" },
      { name: "Idaho", code: "ID" },
      { name: "Illinois", code: "IL" },
      { name: "Indiana", code: "IN" },
      { name: "Iowa", code: "IA" },
      { name: "Kansas", code: "KS" },
      { name: "Kentucky", code: "KY" },
      { name: "Louisiana", code: "LA" },
      { name: "Maine", code: "ME" },
      { name: "Maryland", code: "MD" },
      { name: "Massachusetts", code: "MA" },
      { name: "Michigan", code: "MI" },
      { name: "Minnesota", code: "MN" },
      { name: "Mississippi", code: "MS" },
      { name: "Missouri", code: "MO" },
      { name: "Montana", code: "MT" },
      { name: "Nebraska", code: "NE" },
      { name: "Nevada", code: "NV" },
      { name: "New Hampshire", code: "NH" },
      { name: "New Jersey", code: "NJ" },
      { name: "New Mexico", code: "NM" },
      { name: "New York", code: "NY" },
      { name: "North Carolina", code: "NC" },
      { name: "North Dakota", code: "ND" },
      { name: "Ohio", code: "OH" },
      { name: "Oklahoma", code: "OK" },
      { name: "Oregon", code: "OR" },
      { name: "Pennsylvania", code: "PA" },
      { name: "Rhode Island", code: "RI" },
      { name: "South Carolina", code: "SC" },
      { name: "South Dakota", code: "SD" },
      { name: "Tennessee", code: "TN" },
      { name: "Texas", code: "TX" },
      { name: "Utah", code: "UT" },
      { name: "Vermont", code: "VT" },
      { name: "Virginia", code: "VA" },
      { name: "Washington", code: "WA" },
      { name: "West Virginia", code: "WV" },
      { name: "Wisconsin", code: "WI" },
      { name: "Wyoming", code: "WY" },
      { name: "District of Columbia", code: "DC" },
      { name: "Puerto Rico", code: "PR" },
      { name: "Guam", code: "GU" },
      { name: "U.S. Virgin Islands", code: "VI" },
    ],
  },

  {
    name: "Canada",
    code: "CA",
    states: [
      { name: "Alberta", code: "AB" },
      { name: "British Columbia", code: "BC" },
      { name: "Manitoba", code: "MB" },
      { name: "New Brunswick", code: "NB" },
      { name: "Newfoundland and Labrador", code: "NL" },
      { name: "Northwest Territories", code: "NT" },
      { name: "Nova Scotia", code: "NS" },
      { name: "Nunavut", code: "NU" },
      { name: "Ontario", code: "ON" },
      { name: "Prince Edward Island", code: "PE" },
      { name: "Quebec", code: "QC" },
      { name: "Saskatchewan", code: "SK" },
      { name: "Yukon", code: "YT" },
    ],
  },

  {
    name: "India",
    code: "IN",
    states: [
      { name: "Andhra Pradesh", code: "AP" },
      { name: "Arunachal Pradesh", code: "AR" },
      { name: "Assam", code: "AS" },
      { name: "Bihar", code: "BR" },
      { name: "Chhattisgarh", code: "CG" },
      { name: "Goa", code: "GA" },
      { name: "Gujarat", code: "GJ" },
      { name: "Haryana", code: "HR" },
      { name: "Himachal Pradesh", code: "HP" },
      { name: "Jharkhand", code: "JH" },
      { name: "Karnataka", code: "KA" },
      { name: "Kerala", code: "KL" },
      { name: "Madhya Pradesh", code: "MP" },
      { name: "Maharashtra", code: "MH" },
      { name: "Manipur", code: "MN" },
      { name: "Meghalaya", code: "ML" },
      { name: "Mizoram", code: "MZ" },
      { name: "Nagaland", code: "NL" },
      { name: "Odisha", code: "OD" },
      { name: "Punjab", code: "PB" },
      { name: "Rajasthan", code: "RJ" },
      { name: "Sikkim", code: "SK" },
      { name: "Tamil Nadu", code: "TN" },
      { name: "Telangana", code: "TS" },
      { name: "Tripura", code: "TR" },
      { name: "Uttar Pradesh", code: "UP" },
      { name: "Uttarakhand", code: "UK" },
      { name: "West Bengal", code: "WB" },
      { name: "Andaman and Nicobar Islands", code: "AN" },
      { name: "Chandigarh", code: "CH" },
      { name: "Dadra and Nagar Haveli and Daman and Diu", code: "DH" },
      { name: "Delhi", code: "DL" },
      { name: "Jammu and Kashmir", code: "JK" },
      { name: "Ladakh", code: "LA" },
      { name: "Lakshadweep", code: "LD" },
      { name: "Puducherry", code: "PY" },
    ],
  },

  {
    name: "Australia",
    code: "AU",
    states: [
      { name: "Australian Capital Territory", code: "ACT" },
      { name: "New South Wales", code: "NSW" },
      { name: "Northern Territory", code: "NT" },
      { name: "Queensland", code: "QLD" },
      { name: "South Australia", code: "SA" },
      { name: "Tasmania", code: "TAS" },
      { name: "Victoria", code: "VIC" },
      { name: "Western Australia", code: "WA" },
    ],
  },

  {
    name: "Mexico",
    code: "MX",
    states: [
      { name: "Aguascalientes", code: "AGU" },
      { name: "Baja California", code: "BCN" },
      { name: "Baja California Sur", code: "BCS" },
      { name: "Campeche", code: "CAM" },
      { name: "Chiapas", code: "CHP" },
      { name: "Chihuahua", code: "CHH" },
      { name: "Coahuila", code: "COA" },
      { name: "Colima", code: "COL" },
      { name: "Durango", code: "DUR" },
      { name: "Guanajuato", code: "GUA" },
      { name: "Guerrero", code: "GRO" },
      { name: "Hidalgo", code: "HID" },
      { name: "Jalisco", code: "JAL" },
      { name: "Mexico City", code: "CMX" },
      { name: "Michoacán", code: "MIC" },
      { name: "Morelos", code: "MOR" },
      { name: "Nayarit", code: "NAY" },
      { name: "Nuevo León", code: "NLE" },
      { name: "Oaxaca", code: "OAX" },
      { name: "Puebla", code: "PUE" },
      { name: "Querétaro", code: "QUE" },
      { name: "Quintana Roo", code: "ROO" },
      { name: "San Luis Potosí", code: "SLP" },
      { name: "Sinaloa", code: "SIN" },
      { name: "Sonora", code: "SON" },
      { name: "Tabasco", code: "TAB" },
      { name: "Tamaulipas", code: "TAM" },
      { name: "Tlaxcala", code: "TLA" },
      { name: "Veracruz", code: "VER" },
      { name: "Yucatán", code: "YUC" },
      { name: "Zacatecas", code: "ZAC" },
    ],
  },

  {
    name: "Brazil",
    code: "BR",
    states: [
      { name: "Acre", code: "AC" },
      { name: "Alagoas", code: "AL" },
      { name: "Amapá", code: "AP" },
      { name: "Amazonas", code: "AM" },
      { name: "Bahia", code: "BA" },
      { name: "Ceará", code: "CE" },
      { name: "Distrito Federal", code: "DF" },
      { name: "Espírito Santo", code: "ES" },
      { name: "Goiás", code: "GO" },
      { name: "Maranhão", code: "MA" },
      { name: "Mato Grosso", code: "MT" },
      { name: "Mato Grosso do Sul", code: "MS" },
      { name: "Minas Gerais", code: "MG" },
      { name: "Pará", code: "PA" },
      { name: "Paraíba", code: "PB" },
      { name: "Paraná", code: "PR" },
      { name: "Pernambuco", code: "PE" },
      { name: "Piauí", code: "PI" },
      { name: "Rio de Janeiro", code: "RJ" },
      { name: "Rio Grande do Norte", code: "RN" },
      { name: "Rio Grande do Sul", code: "RS" },
      { name: "Rondônia", code: "RO" },
      { name: "Roraima", code: "RR" },
      { name: "Santa Catarina", code: "SC" },
      { name: "São Paulo", code: "SP" },
      { name: "Sergipe", code: "SE" },
      { name: "Tocantins", code: "TO" },
    ],
  },

  {
    name: "China",
    code: "CN",
    states: [
      { name: "Beijing", code: "BJ" },
      { name: "Shanghai", code: "SH" },
      { name: "Guangdong", code: "GD" },
      { name: "Zhejiang", code: "ZJ" },
      { name: "Jiangsu", code: "JS" },
      { name: "Sichuan", code: "SC" },
      { name: "Fujian", code: "FJ" },
      { name: "Shandong", code: "SD" },
      { name: "Henan", code: "HA" },
      { name: "Hubei", code: "HB" },
    ],
  },

  {
    name: "Japan",
    code: "JP",
    states: [
      { name: "Tokyo", code: "13" },
      { name: "Osaka", code: "27" },
      { name: "Kanagawa", code: "14" },
      { name: "Aichi", code: "23" },
      { name: "Hokkaido", code: "01" },
      { name: "Fukuoka", code: "40" },
    ],
  },

  {
    name: "United Kingdom",
    code: "GB",
    states: [
      { name: "England", code: "ENG" },
      { name: "Scotland", code: "SCT" },
      { name: "Wales", code: "WLS" },
      { name: "Northern Ireland", code: "NIR" },
    ],
  },

  {
    name: "Germany",
    code: "DE",
    states: [
      { name: "Bavaria", code: "BY" },
      { name: "Berlin", code: "BE" },
      { name: "Hamburg", code: "HH" },
      { name: "Hesse", code: "HE" },
      { name: "North Rhine-Westphalia", code: "NW" },
    ],
  },

  {
    name: "France",
    code: "FR",
    states: [
      { name: "Île-de-France", code: "IDF" },
      { name: "Provence-Alpes-Côte d'Azur", code: "PAC" },
      { name: "Nouvelle-Aquitaine", code: "NAQ" },
    ],
  },

  {
    name: "Italy",
    code: "IT",
    states: [
      { name: "Lombardy", code: "LOM" },
      { name: "Lazio", code: "LAZ" },
      { name: "Sicily", code: "SIC" },
    ],
  },

  {
    name: "Spain",
    code: "ES",
    states: [
      { name: "Madrid", code: "MD" },
      { name: "Catalonia", code: "CT" },
      { name: "Andalusia", code: "AN" },
    ],
  },

  {
    name: "United Arab Emirates",
    code: "AE",
    states: [
      { name: "Abu Dhabi", code: "AZ" },
      { name: "Dubai", code: "DU" },
      { name: "Sharjah", code: "SH" },
      { name: "Ajman", code: "AJ" },
      { name: "Ras Al Khaimah", code: "RK" },
      { name: "Fujairah", code: "FU" },
      { name: "Umm Al Quwain", code: "UQ" },
    ],
  },

  {
    name: "South Africa",
    code: "ZA",
    states: [
      { name: "Eastern Cape", code: "EC" },
      { name: "Free State", code: "FS" },
      { name: "Gauteng", code: "GP" },
      { name: "KwaZulu-Natal", code: "KZN" },
      { name: "Limpopo", code: "LP" },
      { name: "Mpumalanga", code: "MP" },
      { name: "Northern Cape", code: "NC" },
      { name: "North West", code: "NW" },
      { name: "Western Cape", code: "WC" },
    ],
  },

  // Countries without required state/province codes
  { name: "Netherlands", code: "NL", states: [] },
  { name: "Belgium", code: "BE", states: [] },
  { name: "Switzerland", code: "CH", states: [] },
  { name: "Austria", code: "AT", states: [] },
  { name: "Sweden", code: "SE", states: [] },
  { name: "Norway", code: "NO", states: [] },
  { name: "Denmark", code: "DK", states: [] },
  { name: "Finland", code: "FI", states: [] },
  { name: "Poland", code: "PL", states: [] },
  { name: "Portugal", code: "PT", states: [] },
  { name: "Ireland", code: "IE", states: [] },
  { name: "South Korea", code: "KR", states: [] },
  { name: "Singapore", code: "SG", states: [] },
  { name: "Hong Kong", code: "HK", states: [] },
  { name: "New Zealand", code: "NZ", states: [] },
  { name: "Argentina", code: "AR", states: [] },
  { name: "Chile", code: "CL", states: [] },
  { name: "Colombia", code: "CO", states: [] },
  { name: "Saudi Arabia", code: "SA", states: [] },
  { name: "Israel", code: "IL", states: [] },
  { name: "Turkey", code: "TR", states: [] },
  { name: "Russia", code: "RU", states: [] },
];

export default COUNTRIES;